import { Component } from '@angular/core';

@Component({
  selector: 'app-contest-entry-review',
  templateUrl: './contest-entry-review.component.html',
  styleUrls: ['./contest-entry-review.component.scss']
})
export class ContestEntryReviewComponent {
  // Placeholder component (was referenced in AppModule routes/imports)
}
